import { Box, Center, Flex } from "@chakra-ui/react";

function Footer() {
  return (
    <Flex
      w="full"
      alignItems="center"
      justify="center"
      color="rgb(0 0 0 / 85%)"
      borderColor="rgb(0 0 0 / 85%)"
      borderTop="1px"
      overflowX="hidden"
      fontFamily="'IBM Plex Mono', monospace"
    >
      <Center>
        <Flex
          direction="column"
          w="full"
          color="rgb(0 0 0 / 85%)"
          alignItems="start"
          maxW="55rem"
          py={[6]}
          fontSize=".5rem"
          lineHeight="10px"
          fontWeight="normal"
          px={[6, 6, 8, 0]}
        >
          <Box>APR is subject to change.</Box>
          <Box>
            The information herein is provided to accredited investors and for
            convenience only. Data and values are current as of 1/13/2023, and
            subject to change. Past performance does not guarantee future
            results. All investments carry risk, including the loss of your
            entire investment. Credix does not provide investment advice, and is
            not responsible for the reliability, accuracy, or completeness of
            third-party information. This does not constitute an offer or the
            solicitation of an offer to sell securities, and this material
            should not be relied upon in making any investment decision(s).
          </Box>
        </Flex>
      </Center>
    </Flex>
  );
}

export default Footer;
